import React , { useRef } from "react";
import {Input} from "reactstrap";
import Cleave from "cleave.js/react";
import "cleave.js/dist/addons/cleave-phone.in";
import { numberWithCommas , StrToNum } from "script/commFunc";

/**
 *
 * User : 이연우
 * Date : 2023.05.31
 * @ file : Components/Common/CpmCommInput.js
 * @ Desc : input 컴포넌트
 * @param {string} id - id값 (부모 컴포넌트의 파라미터 key 값으로도 사용)
 * @param {string} type - input Type
 * @param {object} params - 부모 컴포넌트로부터 받아온 파라미터 객체
 * @param {React.SetStateAction} setParams - 부모 컴포넌트로부터 받아온 파라미터 세터
 * @param {boolean} isDisabled - disabled Yn
 * @param {string} label - 라벨
 * @param {boolean} essential - 필수 여부
 * @param {boolean} readOnly - 읽기전옹 여부
 * @param {function} onBlur - onBlur 함수
*/

const CpmCommInput = ({
    id, 
    params, 
    setParams, 
    type, 
    isDisabled,
    label,
    essential = false,
    readOnly = false,
    onBlur,
    maxValue = 1000000000 ,
    unitText ,
}) => {
    const paramNm = id || 'input'
    const commInput = useRef(null);


    const onChangeInput = (e) => {
        if(type === 'number' && maxValue > 0   &&   StrToNum(e.target.value) > Number(maxValue )){
            alert( numberWithCommas(maxValue) +" 이하로 입력해주세요") ;
            if (commInput.current) {
                e.target.value  = maxValue  ;
                setParams({[paramNm]: maxValue });
            }
            return false ;
        }
        try{
            setParams({ [paramNm]: type === 'number'?   StrToNum(e.target.value) : e.target.value  });
        }catch (e1) {
            console.log(e1)
        }
    };

    return (
        <>
            {type === 'number' ?
            <div className="d-flex align-items-center">
                <Cleave
                    name={label || paramNm}
                    id={id}
                    className={`${essential && 'essential'} form-control form-control-sm me-2`}
                    style={{textAlign: 'right'}}
                    options={{
                        numeral: true,
                        numeralThousandsGroupStyle: 'thousand'
                    }}
                    value={params[paramNm] ||0}
                    onChange={e => onChangeInput(e)}
                    onBlur={onBlur}
                    disabled={isDisabled} 
                    maxLength={15}
                    autoComplete="off"
                    readOnly={readOnly}
                    ref={commInput}
                    />
                <span style={{width : "40px"}}>{unitText ||'원'}</span>
            </div>
            : 
            <Input
                name={label || paramNm}
                id={id}
                type={type}
                className={`${essential && 'essential'} form-control`}
                bsSize='sm'
                onChange={onChangeInput}
                onBlur={onBlur}
                value={params[paramNm] || ''}
                disabled={isDisabled} 
                maxLength={100}
                autoComplete="off"
                readOnly={readOnly}
                ref={commInput}
                />
            }
        </>
    );
};

export default CpmCommInput;
